// extracted by mini-css-extract-plugin
export default {"button":"FLQOP1","icon":"vQKmU5"};